import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsCurrencyField as CurrencyField } from './src/CurrencyField.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(CurrencyField);
export const FsSsnField = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-currency-field.js.map